import { useState } from 'react';
import { Button, Card, CardContent, Skeleton } from '@billda/design-system';
import { ChevronLeftIcon, ChevronRightIcon } from '@billda/design-system';
import { SiteBurndownChart } from '../../sites/components/SiteBurndownChart';
import { useSitesSummary } from '../../sites/hooks/useSitesSummary';

export function DashboardSiteBurndown() {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const { data: sites, isLoading } = useSitesSummary();

  if (isLoading) {
    return <LoadingSkeleton />;
  }

  if (!sites || sites.length === 0) {
    return (
      <Card data-testid="dashboard-site-burndown">
        <CardContent className="p-6">
          <div className="flex h-[200px] items-center justify-center">
            <p className="type-body-md text-content-secondary">
              No sites available
            </p>
          </div>
        </CardContent>
      </Card>
    );
  }

  const currentSite = sites[selectedIndex];

  return (
    <Card data-testid="dashboard-site-burndown">
      <CardContent className="p-6">
        <div className="mb-2 flex items-center justify-center">
          <Button
            variant="ghost"
            size="icon"
            aria-label="Previous site"
            data-testid="dashboard-site-burndown-prev"
            disabled={selectedIndex === 0}
            onClick={() => setSelectedIndex(i => i - 1)}
            className="size-8 p-0"
          >
            <ChevronLeftIcon aria-hidden="true" className="size-4" />
          </Button>
          <p className="mx-1 type-body-lg font-bold">{currentSite.name}</p>
          <Button
            variant="ghost"
            size="icon"
            aria-label="Next site"
            data-testid="dashboard-site-burndown-next"
            disabled={selectedIndex === sites.length - 1}
            onClick={() => setSelectedIndex(i => i + 1)}
            className="size-8 p-0"
          >
            <ChevronRightIcon aria-hidden="true" className="size-4" />
          </Button>
        </div>
        <SiteBurndownChart siteId={currentSite.id} />
      </CardContent>
    </Card>
  );
}

function LoadingSkeleton() {
  return (
    <Card data-testid="dashboard-site-burndown-loading">
      <CardContent className="p-6">
        <Skeleton width={200} height={24} className="mb-0.5" />
        <Skeleton width={120} height={18} className="mb-6" />
        <Skeleton variant="rectangular" height={300} className="rounded-lg" />
      </CardContent>
    </Card>
  );
}
